// src/frontend/data/books/BlockchainFundamentals/data/cap11.js

const CAP12 = {
  id: 11,
  slug: "cap11-hedera-hashgraph-hbar",
  title: "Capítulo 11 — Hedera Hashgraph (HBAR): DAG, consenso rápido y adopción empresarial",
  sections: [
    {
      heading: "¿Qué es Hedera Hashgraph?",
      text: [
        "Hedera Hashgraph es una red pública de tecnología de libro mayor distribuido (DLT) diseñada para ofrecer alta velocidad, escalabilidad, estabilidad y seguridad.",
        "Permite a personas y empresas interactuar y realizar transacciones en línea de forma eficiente y segura, sin necesidad de intermediarios tradicionales.",
        "Su token nativo es HBAR, utilizado como medio de pago de comisiones, mecanismo de seguridad y participación dentro de la red."
      ]
    },
    {
      heading: "Objetivo principal del proyecto",
      text: [
        "A diferencia de muchas criptomonedas, Hedera no se enfoca principalmente en ser dinero digital para especulación.",
        "Su objetivo central es proporcionar una infraestructura de nivel empresarial para aplicaciones descentralizadas de alto volumen.",
        "El token HBAR actúa como un medio para asegurar la red, interactuar con dApps y construir modelos transaccionales peer-to-peer (P2P)."
      ]
    },
    {
      heading: "Una red pensada para empresas y desarrolladores",
      text: [
        "Hedera está diseñada para soportar aplicaciones masivas con alta concurrencia.",
        "Esto la hace atractiva para casos de uso empresariales donde otras blockchains sufren congestión, lentitud o altos costos.",
        "La red prioriza confiabilidad, previsibilidad de costos y rendimiento constante."
      ]
    },

    // ===== Tecnología base =====
    {
      heading: "DAG y Hashgraph: la base tecnológica",
      text: [
        "La principal fortaleza de Hedera reside en su uso de un grafo acíclico dirigido (DAG) en lugar de una blockchain tradicional.",
        "Sobre este DAG opera el protocolo de consenso Hashgraph, que permite alcanzar consenso de forma extremadamente rápida y eficiente.",
        "Gracias a este diseño, Hedera puede procesar transacciones a velocidades muy superiores a redes basadas en Proof of Work (PoW) o Proof of Stake (PoS)."
      ]
    },
    {
      heading: "¿Qué es un DAG (Grafo Acíclico Dirigido)?",
      text: [
        "Un DAG es una estructura de datos donde las transacciones se organizan como nodos conectados sin formar ciclos.",
        "Esto permite que múltiples transacciones se procesen en paralelo, en lugar de en bloques secuenciales.",
        "El resultado es mayor rendimiento, menor latencia y mejor escalabilidad."
      ]
    },
    {
      heading: "Consenso Hashgraph (explicado en simple)",
      text: [
        "Hashgraph utiliza un mecanismo llamado gossip about gossip, donde los nodos comparten información de forma eficiente.",
        "A través de este intercambio y de marcas temporales virtuales, la red alcanza consenso sin necesidad de minería.",
        "El consenso es rápido, justo (orden justo de transacciones) y tolerante a fallas bizantinas (aBFT)."
      ]
    },

    // ===== Servicios =====
    {
      heading: "Servicios principales de la red Hedera",
      list: [
        "Criptomoneda (HBAR): transferencias rápidas y de bajo costo.",
        "Smart Contracts: contratos inteligentes compatibles con la EVM.",
        "Hedera Consensus Service (HCS): servicio de consenso para mensajes y eventos.",
        "File Service: almacenamiento de archivos en la red."
      ]
    },
    {
      heading: "Aplicaciones posibles sobre Hedera",
      text: [
        "Los desarrolladores pueden construir dApps masivas sin preocuparse por congestión de red.",
        "Casos de uso incluyen pagos, tokenización, NFTs, identidad digital, CBDCs, logística, salud y cadena de suministro.",
        "Hedera está orientada a soluciones de alcance global y uso empresarial."
      ]
    },

    // ===== Token HBAR =====
    {
      heading: "¿Qué es el token HBAR?",
      text: [
        "HBAR es el token nativo de Hedera Hashgraph.",
        "Tiene un suministro máximo fijo de 50 mil millones de HBAR, acuñados inicialmente y controlados por la Hedera Treasury.",
        "El Tesoro de Hedera administra la liberación gradual de tokens según un plan aprobado por el Consejo de Gobierno."
      ]
    },
    {
      heading: "Hedera Treasury y control de emisión",
      text: [
        "Los tokens HBAR solo pueden liberarse desde cuentas del Tesoro.",
        "Estas liberaciones requieren aprobación por mayoría del Consejo de Gobierno de Hedera.",
        "Este modelo busca equilibrio entre control, previsibilidad económica y descentralización institucional."
      ]
    },
    {
      heading: "Distribución inicial y apertura de la red",
      text: [
        "En los inicios, se liberaron alrededor de 6,7 millones de HBAR para pruebas de red.",
        "El 16 de septiembre de 2019 se aprobó la apertura pública de la red.",
        "Posteriormente se distribuyeron HBAR a titulares de SAFT, empleados, asesores y proveedores, iniciando la comercialización libre del token."
      ]
    },
    {
      heading: "HBAR en circulación",
      text: [
        "El plan de liberación prevé una salida lenta y controlada desde la Hedera Treasury.",
        "Según datos divulgativos, actualmente existen más de 19,5 mil millones de HBAR en circulación.",
        "Este esquema busca evitar choques inflacionarios abruptos."
      ]
    },

    // ===== Funciones económicas =====
    {
      heading: "Funciones del token HBAR",
      list: [
        "Pago de comisiones dentro de la red (gas y servicios).",
        "Incentivar a los nodos que aportan recursos computacionales.",
        "Mecanismo de seguridad frente a ataques.",
        "Pago de recompensas a nodos y, en el futuro, a esquemas de staking."
      ]
    },
    {
      heading: "Estructura de comisiones en Hedera",
      text: [
        "Las comisiones en Hedera son muy bajas, con costos aproximados desde 0,00001 USD por transacción.",
        "Las tarifas están divididas en varias partes para incentivar a todos los actores del sistema."
      ]
    },
    {
      heading: "Tipos de comisiones",
      list: [
        "Comisión del nodo: recompensa al nodo que recibe y transmite la transacción.",
        "Comisión de red: compensa a los nodos que participan en el consenso.",
        "Comisión de servicio: depende del tipo de operación (transferencia, contrato, almacenamiento, mensajes).",
        "Comisión de aplicación (opcional): cobrada por dApps que monetizan su servicio."
      ]
    },

    // ===== Usos =====
    {
      heading: "Usos actuales del token HBAR",
      text: [
        "HBAR se utiliza para interactuar con dApps dentro del ecosistema Hedera.",
        "Proyectos como Carbon, Arbit o Tune.fm son ejemplos de aplicaciones activas.",
        "También se usa en pagos, tokenización, NFTs, identidad digital y soluciones empresariales."
      ]
    },

    // ===== Ventajas / retos =====
    {
      heading: "Ventajas de Hedera Hashgraph",
      list: [
        "Altísima velocidad de transacción.",
        "Escalabilidad muy superior a blockchains tradicionales.",
        "Costos previsibles y extremadamente bajos.",
        "Consenso aBFT (alto nivel de seguridad).",
        "Orientación clara a adopción empresarial."
      ]
    },
    {
      heading: "Retos y críticas",
      list: [
        "Modelo de gobernanza con grandes corporaciones genera debate sobre descentralización.",
        "Dependencia inicial del Consejo de Gobierno.",
        "Menor presencia en cultura cripto ‘hardcore’ frente a proyectos puramente comunitarios."
      ]
    },

    // ===== Conclusión =====
    {
      heading: "Conclusión",
      text: [
        "Hedera Hashgraph representa una alternativa tecnológica a la blockchain tradicional.",
        "Su uso de DAG y consenso Hashgraph permite velocidades y escalabilidad excepcionales.",
        "HBAR no busca ser solo dinero digital, sino el combustible de una red empresarial descentralizada.",
        "Comprender Hedera es entender hacia dónde pueden evolucionar las DLT cuando el foco está en rendimiento, estabilidad y adopción real."
      ]
    }
  ]
};

export default CAP12;

